import { createContext } from 'react'

import { ApiClient } from './types'

const context = createContext<ApiClient | undefined>(undefined)

export default context
